import {ErrorFileField, FILE_Field_ERROR} from "../models";

export const fileToBase64 = (file: Blob) => {
  return new Promise<string>((res, rej) => {
    let fileReader = new FileReader()
    fileReader.onload = (e) => {
      if (!e.target) {
        return rej(new ErrorFileField('error-load', FILE_Field_ERROR.LOAD))
      }
      return res(String(e.target.result))
    }
    fileReader.onerror = rej
    fileReader.readAsDataURL(file)
  })
}
